export default function(item) {
  var group = this.context.group,
      value = false;

  if (group) while (item) {
    if (item === group) { value = true; break; }
    item = item.mark.group;
  }
  return value;
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-parser/src/parsers/expression/inscope.js
// module id = 1424
// module chunks = 0